import './spacing.css';
export default {
  "mAuto": "pf-v5-u-m-auto",
  "mAutoOnLg": "pf-v5-u-m-auto-on-lg",
  "mAutoOnMd": "pf-v5-u-m-auto-on-md",
  "mAutoOnSm": "pf-v5-u-m-auto-on-sm",
  "mAutoOnXl": "pf-v5-u-m-auto-on-xl",
  "mAutoOn_2xl": "pf-v5-u-m-auto-on-2xl",
  "mLg": "pf-v5-u-m-lg",
  "mLgOnLg": "pf-v5-u-m-lg-on-lg",
  "mLgOnMd": "pf-v5-u-m-lg-on-md",
  "mLgOnSm": "pf-v5-u-m-lg-on-sm",
  "mLgOnXl": "pf-v5-u-m-lg-on-xl",
  "mLgOn_2xl": "pf-v5-u-m-lg-on-2xl",
  "mMd": "pf-v5-u-m-md",
  "mMdOnLg": "pf-v5-u-m-md-on-lg",
  "mMdOnMd": "pf-v5-u-m-md-on-md",
  "mMdOnSm": "pf-v5-u-m-md-on-sm",
  "mMdOnXl": "pf-v5-u-m-md-on-xl",
  "mMdOn_2xl": "pf-v5-u-m-md-on-2xl",
  "mSm": "pf-v5-u-m-sm",
  "mSmOnLg": "pf-v5-u-m-sm-on-lg",
  "mSmOnMd": "pf-v5-u-m-sm-on-md",
  "mSmOnSm": "pf-v5-u-m-sm-on-sm",
  "mSmOnXl": "pf-v5-u-m-sm-on-xl",
  "mSmOn_2xl": "pf-v5-u-m-sm-on-2xl",
  "mXl": "pf-v5-u-m-xl",
  "mXlOnLg": "pf-v5-u-m-xl-on-lg",
  "mXlOnMd": "pf-v5-u-m-xl-on-md",
  "mXlOnSm": "pf-v5-u-m-xl-on-sm",
  "mXlOnXl": "pf-v5-u-m-xl-on-xl",
  "mXlOn_2xl": "pf-v5-u-m-xl-on-2xl",
  "mXs": "pf-v5-u-m-xs",
  "mXsOnLg": "pf-v5-u-m-xs-on-lg",
  "mXsOnMd": "pf-v5-u-m-xs-on-md",
  "mXsOnSm": "pf-v5-u-m-xs-on-sm",
  "mXsOnXl": "pf-v5-u-m-xs-on-xl",
  "mXsOn_2xl": "pf-v5-u-m-xs-on-2xl",
  "m_0": "pf-v5-u-m-0",
  "m_0OnLg": "pf-v5-u-m-0-on-lg",
  "m_0OnMd": "pf-v5-u-m-0-on-md",
  "m_0OnSm": "pf-v5-u-m-0-on-sm",
  "m_0OnXl": "pf-v5-u-m-0-on-xl",
  "m_0On_2xl": "pf-v5-u-m-0-on-2xl",
  "m_2xl": "pf-v5-u-m-2xl",
  "m_2xlOnLg": "pf-v5-u-m-2xl-on-lg",
  "m_2xlOnMd": "pf-v5-u-m-2xl-on-md",
  "m_2xlOnSm": "pf-v5-u-m-2xl-on-sm",
  "m_2xlOnXl": "pf-v5-u-m-2xl-on-xl",
  "m_2xlOn_2xl": "pf-v5-u-m-2xl-on-2xl",
  "m_3xl": "pf-v5-u-m-3xl",
  "m_3xlOnLg": "pf-v5-u-m-3xl-on-lg",
  "m_3xlOnMd": "pf-v5-u-m-3xl-on-md",
  "m_3xlOnSm": "pf-v5-u-m-3xl-on-sm",
  "m_3xlOnXl": "pf-v5-u-m-3xl-on-xl",
  "m_3xlOn_2xl": "pf-v5-u-m-3xl-on-2xl",
  "m_4xl": "pf-v5-u-m-4xl",
  "m_4xlOnLg": "pf-v5-u-m-4xl-on-lg",
  "m_4xlOnMd": "pf-v5-u-m-4xl-on-md",
  "m_4xlOnSm": "pf-v5-u-m-4xl-on-sm",
  "m_4xlOnXl": "pf-v5-u-m-4xl-on-xl",
  "m_4xlOn_2xl": "pf-v5-u-m-4xl-on-2xl",
  "mbAuto": "pf-v5-u-mb-auto",
  "mbAutoOnLg": "pf-v5-u-mb-auto-on-lg",
  "mbAutoOnMd": "pf-v5-u-mb-auto-on-md",
  "mbAutoOnSm": "pf-v5-u-mb-auto-on-sm",
  "mbAutoOnXl": "pf-v5-u-mb-auto-on-xl",
  "mbAutoOn_2xl": "pf-v5-u-mb-auto-on-2xl",
  "mbLg": "pf-v5-u-mb-lg",
  "mbLgOnLg": "pf-v5-u-mb-lg-on-lg",
  "mbLgOnMd": "pf-v5-u-mb-lg-on-md",
  "mbLgOnSm": "pf-v5-u-mb-lg-on-sm",
  "mbLgOnXl": "pf-v5-u-mb-lg-on-xl",
  "mbLgOn_2xl": "pf-v5-u-mb-lg-on-2xl",
  "mbMd": "pf-v5-u-mb-md",
  "mbMdOnLg": "pf-v5-u-mb-md-on-lg",
  "mbMdOnMd": "pf-v5-u-mb-md-on-md",
  "mbMdOnSm": "pf-v5-u-mb-md-on-sm",
  "mbMdOnXl": "pf-v5-u-mb-md-on-xl",
  "mbMdOn_2xl": "pf-v5-u-mb-md-on-2xl",
  "mbSm": "pf-v5-u-mb-sm",
  "mbSmOnLg": "pf-v5-u-mb-sm-on-lg",
  "mbSmOnMd": "pf-v5-u-mb-sm-on-md",
  "mbSmOnSm": "pf-v5-u-mb-sm-on-sm",
  "mbSmOnXl": "pf-v5-u-mb-sm-on-xl",
  "mbSmOn_2xl": "pf-v5-u-mb-sm-on-2xl",
  "mbXl": "pf-v5-u-mb-xl",
  "mbXlOnLg": "pf-v5-u-mb-xl-on-lg",
  "mbXlOnMd": "pf-v5-u-mb-xl-on-md",
  "mbXlOnSm": "pf-v5-u-mb-xl-on-sm",
  "mbXlOnXl": "pf-v5-u-mb-xl-on-xl",
  "mbXlOn_2xl": "pf-v5-u-mb-xl-on-2xl",
  "mbXs": "pf-v5-u-mb-xs",
  "mbXsOnLg": "pf-v5-u-mb-xs-on-lg",
  "mbXsOnMd": "pf-v5-u-mb-xs-on-md",
  "mbXsOnSm": "pf-v5-u-mb-xs-on-sm",
  "mbXsOnXl": "pf-v5-u-mb-xs-on-xl",
  "mbXsOn_2xl": "pf-v5-u-mb-xs-on-2xl",
  "mb_0": "pf-v5-u-mb-0",
  "mb_0OnLg": "pf-v5-u-mb-0-on-lg",
  "mb_0OnMd": "pf-v5-u-mb-0-on-md",
  "mb_0OnSm": "pf-v5-u-mb-0-on-sm",
  "mb_0OnXl": "pf-v5-u-mb-0-on-xl",
  "mb_0On_2xl": "pf-v5-u-mb-0-on-2xl",
  "mb_2xl": "pf-v5-u-mb-2xl",
  "mb_2xlOnLg": "pf-v5-u-mb-2xl-on-lg",
  "mb_2xlOnMd": "pf-v5-u-mb-2xl-on-md",
  "mb_2xlOnSm": "pf-v5-u-mb-2xl-on-sm",
  "mb_2xlOnXl": "pf-v5-u-mb-2xl-on-xl",
  "mb_2xlOn_2xl": "pf-v5-u-mb-2xl-on-2xl",
  "mb_3xl": "pf-v5-u-mb-3xl",
  "mb_3xlOnLg": "pf-v5-u-mb-3xl-on-lg",
  "mb_3xlOnMd": "pf-v5-u-mb-3xl-on-md",
  "mb_3xlOnSm": "pf-v5-u-mb-3xl-on-sm",
  "mb_3xlOnXl": "pf-v5-u-mb-3xl-on-xl",
  "mb_3xlOn_2xl": "pf-v5-u-mb-3xl-on-2xl",
  "mb_4xl": "pf-v5-u-mb-4xl",
  "mb_4xlOnLg": "pf-v5-u-mb-4xl-on-lg",
  "mb_4xlOnMd": "pf-v5-u-mb-4xl-on-md",
  "mb_4xlOnSm": "pf-v5-u-mb-4xl-on-sm",
  "mb_4xlOnXl": "pf-v5-u-mb-4xl-on-xl",
  "mb_4xlOn_2xl": "pf-v5-u-mb-4xl-on-2xl",
  "mlAuto": "pf-v5-u-ml-auto",
  "mlAutoOnLg": "pf-v5-u-ml-auto-on-lg",
  "mlAutoOnMd": "pf-v5-u-ml-auto-on-md",
  "mlAutoOnSm": "pf-v5-u-ml-auto-on-sm",
  "mlAutoOnXl": "pf-v5-u-ml-auto-on-xl",
  "mlAutoOn_2xl": "pf-v5-u-ml-auto-on-2xl",
  "mlLg": "pf-v5-u-ml-lg",
  "mlLgOnLg": "pf-v5-u-ml-lg-on-lg",
  "mlLgOnMd": "pf-v5-u-ml-lg-on-md",
  "mlLgOnSm": "pf-v5-u-ml-lg-on-sm",
  "mlLgOnXl": "pf-v5-u-ml-lg-on-xl",
  "mlLgOn_2xl": "pf-v5-u-ml-lg-on-2xl",
  "mlMd": "pf-v5-u-ml-md",
  "mlMdOnLg": "pf-v5-u-ml-md-on-lg",
  "mlMdOnMd": "pf-v5-u-ml-md-on-md",
  "mlMdOnSm": "pf-v5-u-ml-md-on-sm",
  "mlMdOnXl": "pf-v5-u-ml-md-on-xl",
  "mlMdOn_2xl": "pf-v5-u-ml-md-on-2xl",
  "mlSm": "pf-v5-u-ml-sm",
  "mlSmOnLg": "pf-v5-u-ml-sm-on-lg",
  "mlSmOnMd": "pf-v5-u-ml-sm-on-md",
  "mlSmOnSm": "pf-v5-u-ml-sm-on-sm",
  "mlSmOnXl": "pf-v5-u-ml-sm-on-xl",
  "mlSmOn_2xl": "pf-v5-u-ml-sm-on-2xl",
  "mlXl": "pf-v5-u-ml-xl",
  "mlXlOnLg": "pf-v5-u-ml-xl-on-lg",
  "mlXlOnMd": "pf-v5-u-ml-xl-on-md",
  "mlXlOnSm": "pf-v5-u-ml-xl-on-sm",
  "mlXlOnXl": "pf-v5-u-ml-xl-on-xl",
  "mlXlOn_2xl": "pf-v5-u-ml-xl-on-2xl",
  "mlXs": "pf-v5-u-ml-xs",
  "mlXsOnLg": "pf-v5-u-ml-xs-on-lg",
  "mlXsOnMd": "pf-v5-u-ml-xs-on-md",
  "mlXsOnSm": "pf-v5-u-ml-xs-on-sm",
  "mlXsOnXl": "pf-v5-u-ml-xs-on-xl",
  "mlXsOn_2xl": "pf-v5-u-ml-xs-on-2xl",
  "ml_0": "pf-v5-u-ml-0",
  "ml_0OnLg": "pf-v5-u-ml-0-on-lg",
  "ml_0OnMd": "pf-v5-u-ml-0-on-md",
  "ml_0OnSm": "pf-v5-u-ml-0-on-sm",
  "ml_0OnXl": "pf-v5-u-ml-0-on-xl",
  "ml_0On_2xl": "pf-v5-u-ml-0-on-2xl",
  "ml_2xl": "pf-v5-u-ml-2xl",
  "ml_2xlOnLg": "pf-v5-u-ml-2xl-on-lg",
  "ml_2xlOnMd": "pf-v5-u-ml-2xl-on-md",
  "ml_2xlOnSm": "pf-v5-u-ml-2xl-on-sm",
  "ml_2xlOnXl": "pf-v5-u-ml-2xl-on-xl",
  "ml_2xlOn_2xl": "pf-v5-u-ml-2xl-on-2xl",
  "ml_3xl": "pf-v5-u-ml-3xl",
  "ml_3xlOnLg": "pf-v5-u-ml-3xl-on-lg",
  "ml_3xlOnMd": "pf-v5-u-ml-3xl-on-md",
  "ml_3xlOnSm": "pf-v5-u-ml-3xl-on-sm",
  "ml_3xlOnXl": "pf-v5-u-ml-3xl-on-xl",
  "ml_3xlOn_2xl": "pf-v5-u-ml-3xl-on-2xl",
  "ml_4xl": "pf-v5-u-ml-4xl",
  "ml_4xlOnLg": "pf-v5-u-ml-4xl-on-lg",
  "ml_4xlOnMd": "pf-v5-u-ml-4xl-on-md",
  "ml_4xlOnSm": "pf-v5-u-ml-4xl-on-sm",
  "ml_4xlOnXl": "pf-v5-u-ml-4xl-on-xl",
  "ml_4xlOn_2xl": "pf-v5-u-ml-4xl-on-2xl",
  "mrAuto": "pf-v5-u-mr-auto",
  "mrAutoOnLg": "pf-v5-u-mr-auto-on-lg",
  "mrAutoOnMd": "pf-v5-u-mr-auto-on-md",
  "mrAutoOnSm": "pf-v5-u-mr-auto-on-sm",
  "mrAutoOnXl": "pf-v5-u-mr-auto-on-xl",
  "mrAutoOn_2xl": "pf-v5-u-mr-auto-on-2xl",
  "mrLg": "pf-v5-u-mr-lg",
  "mrLgOnLg": "pf-v5-u-mr-lg-on-lg",
  "mrLgOnMd": "pf-v5-u-mr-lg-on-md",
  "mrLgOnSm": "pf-v5-u-mr-lg-on-sm",
  "mrLgOnXl": "pf-v5-u-mr-lg-on-xl",
  "mrLgOn_2xl": "pf-v5-u-mr-lg-on-2xl",
  "mrMd": "pf-v5-u-mr-md",
  "mrMdOnLg": "pf-v5-u-mr-md-on-lg",
  "mrMdOnMd": "pf-v5-u-mr-md-on-md",
  "mrMdOnSm": "pf-v5-u-mr-md-on-sm",
  "mrMdOnXl": "pf-v5-u-mr-md-on-xl",
  "mrMdOn_2xl": "pf-v5-u-mr-md-on-2xl",
  "mrSm": "pf-v5-u-mr-sm",
  "mrSmOnLg": "pf-v5-u-mr-sm-on-lg",
  "mrSmOnMd": "pf-v5-u-mr-sm-on-md",
  "mrSmOnSm": "pf-v5-u-mr-sm-on-sm",
  "mrSmOnXl": "pf-v5-u-mr-sm-on-xl",
  "mrSmOn_2xl": "pf-v5-u-mr-sm-on-2xl",
  "mrXl": "pf-v5-u-mr-xl",
  "mrXlOnLg": "pf-v5-u-mr-xl-on-lg",
  "mrXlOnMd": "pf-v5-u-mr-xl-on-md",
  "mrXlOnSm": "pf-v5-u-mr-xl-on-sm",
  "mrXlOnXl": "pf-v5-u-mr-xl-on-xl",
  "mrXlOn_2xl": "pf-v5-u-mr-xl-on-2xl",
  "mrXs": "pf-v5-u-mr-xs",
  "mrXsOnLg": "pf-v5-u-mr-xs-on-lg",
  "mrXsOnMd": "pf-v5-u-mr-xs-on-md",
  "mrXsOnSm": "pf-v5-u-mr-xs-on-sm",
  "mrXsOnXl": "pf-v5-u-mr-xs-on-xl",
  "mrXsOn_2xl": "pf-v5-u-mr-xs-on-2xl",
  "mr_0": "pf-v5-u-mr-0",
  "mr_0OnLg": "pf-v5-u-mr-0-on-lg",
  "mr_0OnMd": "pf-v5-u-mr-0-on-md",
  "mr_0OnSm": "pf-v5-u-mr-0-on-sm",
  "mr_0OnXl": "pf-v5-u-mr-0-on-xl",
  "mr_0On_2xl": "pf-v5-u-mr-0-on-2xl",
  "mr_2xl": "pf-v5-u-mr-2xl",
  "mr_2xlOnLg": "pf-v5-u-mr-2xl-on-lg",
  "mr_2xlOnMd": "pf-v5-u-mr-2xl-on-md",
  "mr_2xlOnSm": "pf-v5-u-mr-2xl-on-sm",
  "mr_2xlOnXl": "pf-v5-u-mr-2xl-on-xl",
  "mr_2xlOn_2xl": "pf-v5-u-mr-2xl-on-2xl",
  "mr_3xl": "pf-v5-u-mr-3xl",
  "mr_3xlOnLg": "pf-v5-u-mr-3xl-on-lg",
  "mr_3xlOnMd": "pf-v5-u-mr-3xl-on-md",
  "mr_3xlOnSm": "pf-v5-u-mr-3xl-on-sm",
  "mr_3xlOnXl": "pf-v5-u-mr-3xl-on-xl",
  "mr_3xlOn_2xl": "pf-v5-u-mr-3xl-on-2xl",
  "mr_4xl": "pf-v5-u-mr-4xl",
  "mr_4xlOnLg": "pf-v5-u-mr-4xl-on-lg",
  "mr_4xlOnMd": "pf-v5-u-mr-4xl-on-md",
  "mr_4xlOnSm": "pf-v5-u-mr-4xl-on-sm",
  "mr_4xlOnXl": "pf-v5-u-mr-4xl-on-xl",
  "mr_4xlOn_2xl": "pf-v5-u-mr-4xl-on-2xl",
  "mtAuto": "pf-v5-u-mt-auto",
  "mtAutoOnLg": "pf-v5-u-mt-auto-on-lg",
  "mtAutoOnMd": "pf-v5-u-mt-auto-on-md",
  "mtAutoOnSm": "pf-v5-u-mt-auto-on-sm",
  "mtAutoOnXl": "pf-v5-u-mt-auto-on-xl",
  "mtAutoOn_2xl": "pf-v5-u-mt-auto-on-2xl",
  "mtLg": "pf-v5-u-mt-lg",
  "mtLgOnLg": "pf-v5-u-mt-lg-on-lg",
  "mtLgOnMd": "pf-v5-u-mt-lg-on-md",
  "mtLgOnSm": "pf-v5-u-mt-lg-on-sm",
  "mtLgOnXl": "pf-v5-u-mt-lg-on-xl",
  "mtLgOn_2xl": "pf-v5-u-mt-lg-on-2xl",
  "mtMd": "pf-v5-u-mt-md",
  "mtMdOnLg": "pf-v5-u-mt-md-on-lg",
  "mtMdOnMd": "pf-v5-u-mt-md-on-md",
  "mtMdOnSm": "pf-v5-u-mt-md-on-sm",
  "mtMdOnXl": "pf-v5-u-mt-md-on-xl",
  "mtMdOn_2xl": "pf-v5-u-mt-md-on-2xl",
  "mtSm": "pf-v5-u-mt-sm",
  "mtSmOnLg": "pf-v5-u-mt-sm-on-lg",
  "mtSmOnMd": "pf-v5-u-mt-sm-on-md",
  "mtSmOnSm": "pf-v5-u-mt-sm-on-sm",
  "mtSmOnXl": "pf-v5-u-mt-sm-on-xl",
  "mtSmOn_2xl": "pf-v5-u-mt-sm-on-2xl",
  "mtXl": "pf-v5-u-mt-xl",
  "mtXlOnLg": "pf-v5-u-mt-xl-on-lg",
  "mtXlOnMd": "pf-v5-u-mt-xl-on-md",
  "mtXlOnSm": "pf-v5-u-mt-xl-on-sm",
  "mtXlOnXl": "pf-v5-u-mt-xl-on-xl",
  "mtXlOn_2xl": "pf-v5-u-mt-xl-on-2xl",
  "mtXs": "pf-v5-u-mt-xs",
  "mtXsOnLg": "pf-v5-u-mt-xs-on-lg",
  "mtXsOnMd": "pf-v5-u-mt-xs-on-md",
  "mtXsOnSm": "pf-v5-u-mt-xs-on-sm",
  "mtXsOnXl": "pf-v5-u-mt-xs-on-xl",
  "mtXsOn_2xl": "pf-v5-u-mt-xs-on-2xl",
  "mt_0": "pf-v5-u-mt-0",
  "mt_0OnLg": "pf-v5-u-mt-0-on-lg",
  "mt_0OnMd": "pf-v5-u-mt-0-on-md",
  "mt_0OnSm": "pf-v5-u-mt-0-on-sm",
  "mt_0OnXl": "pf-v5-u-mt-0-on-xl",
  "mt_0On_2xl": "pf-v5-u-mt-0-on-2xl",
  "mt_2xl": "pf-v5-u-mt-2xl",
  "mt_2xlOnLg": "pf-v5-u-mt-2xl-on-lg",
  "mt_2xlOnMd": "pf-v5-u-mt-2xl-on-md",
  "mt_2xlOnSm": "pf-v5-u-mt-2xl-on-sm",
  "mt_2xlOnXl": "pf-v5-u-mt-2xl-on-xl",
  "mt_2xlOn_2xl": "pf-v5-u-mt-2xl-on-2xl",
  "mt_3xl": "pf-v5-u-mt-3xl",
  "mt_3xlOnLg": "pf-v5-u-mt-3xl-on-lg",
  "mt_3xlOnMd": "pf-v5-u-mt-3xl-on-md",
  "mt_3xlOnSm": "pf-v5-u-mt-3xl-on-sm",
  "mt_3xlOnXl": "pf-v5-u-mt-3xl-on-xl",
  "mt_3xlOn_2xl": "pf-v5-u-mt-3xl-on-2xl",
  "mt_4xl": "pf-v5-u-mt-4xl",
  "mt_4xlOnLg": "pf-v5-u-mt-4xl-on-lg",
  "mt_4xlOnMd": "pf-v5-u-mt-4xl-on-md",
  "mt_4xlOnSm": "pf-v5-u-mt-4xl-on-sm",
  "mt_4xlOnXl": "pf-v5-u-mt-4xl-on-xl",
  "mt_4xlOn_2xl": "pf-v5-u-mt-4xl-on-2xl",
  "mxAuto": "pf-v5-u-mx-auto",
  "mxAutoOnLg": "pf-v5-u-mx-auto-on-lg",
  "mxAutoOnMd": "pf-v5-u-mx-auto-on-md",
  "mxAutoOnSm": "pf-v5-u-mx-auto-on-sm",
  "mxAutoOnXl": "pf-v5-u-mx-auto-on-xl",
  "mxAutoOn_2xl": "pf-v5-u-mx-auto-on-2xl",
  "mxLg": "pf-v5-u-mx-lg",
  "mxLgOnLg": "pf-v5-u-mx-lg-on-lg",
  "mxLgOnMd": "pf-v5-u-mx-lg-on-md",
  "mxLgOnSm": "pf-v5-u-mx-lg-on-sm",
  "mxLgOnXl": "pf-v5-u-mx-lg-on-xl",
  "mxLgOn_2xl": "pf-v5-u-mx-lg-on-2xl",
  "mxMd": "pf-v5-u-mx-md",
  "mxMdOnLg": "pf-v5-u-mx-md-on-lg",
  "mxMdOnMd": "pf-v5-u-mx-md-on-md",
  "mxMdOnSm": "pf-v5-u-mx-md-on-sm",
  "mxMdOnXl": "pf-v5-u-mx-md-on-xl",
  "mxMdOn_2xl": "pf-v5-u-mx-md-on-2xl",
  "mxSm": "pf-v5-u-mx-sm",
  "mxSmOnLg": "pf-v5-u-mx-sm-on-lg",
  "mxSmOnMd": "pf-v5-u-mx-sm-on-md",
  "mxSmOnSm": "pf-v5-u-mx-sm-on-sm",
  "mxSmOnXl": "pf-v5-u-mx-sm-on-xl",
  "mxSmOn_2xl": "pf-v5-u-mx-sm-on-2xl",
  "mxXl": "pf-v5-u-mx-xl",
  "mxXlOnLg": "pf-v5-u-mx-xl-on-lg",
  "mxXlOnMd": "pf-v5-u-mx-xl-on-md",
  "mxXlOnSm": "pf-v5-u-mx-xl-on-sm",
  "mxXlOnXl": "pf-v5-u-mx-xl-on-xl",
  "mxXlOn_2xl": "pf-v5-u-mx-xl-on-2xl",
  "mxXs": "pf-v5-u-mx-xs",
  "mxXsOnLg": "pf-v5-u-mx-xs-on-lg",
  "mxXsOnMd": "pf-v5-u-mx-xs-on-md",
  "mxXsOnSm": "pf-v5-u-mx-xs-on-sm",
  "mxXsOnXl": "pf-v5-u-mx-xs-on-xl",
  "mxXsOn_2xl": "pf-v5-u-mx-xs-on-2xl",
  "mx_0": "pf-v5-u-mx-0",
  "mx_0OnLg": "pf-v5-u-mx-0-on-lg",
  "mx_0OnMd": "pf-v5-u-mx-0-on-md",
  "mx_0OnSm": "pf-v5-u-mx-0-on-sm",
  "mx_0OnXl": "pf-v5-u-mx-0-on-xl",
  "mx_0On_2xl": "pf-v5-u-mx-0-on-2xl",
  "mx_2xl": "pf-v5-u-mx-2xl",
  "mx_2xlOnLg": "pf-v5-u-mx-2xl-on-lg",
  "mx_2xlOnMd": "pf-v5-u-mx-2xl-on-md",
  "mx_2xlOnSm": "pf-v5-u-mx-2xl-on-sm",
  "mx_2xlOnXl": "pf-v5-u-mx-2xl-on-xl",
  "mx_2xlOn_2xl": "pf-v5-u-mx-2xl-on-2xl",
  "mx_3xl": "pf-v5-u-mx-3xl",
  "mx_3xlOnLg": "pf-v5-u-mx-3xl-on-lg",
  "mx_3xlOnMd": "pf-v5-u-mx-3xl-on-md",
  "mx_3xlOnSm": "pf-v5-u-mx-3xl-on-sm",
  "mx_3xlOnXl": "pf-v5-u-mx-3xl-on-xl",
  "mx_3xlOn_2xl": "pf-v5-u-mx-3xl-on-2xl",
  "mx_4xl": "pf-v5-u-mx-4xl",
  "mx_4xlOnLg": "pf-v5-u-mx-4xl-on-lg",
  "mx_4xlOnMd": "pf-v5-u-mx-4xl-on-md",
  "mx_4xlOnSm": "pf-v5-u-mx-4xl-on-sm",
  "mx_4xlOnXl": "pf-v5-u-mx-4xl-on-xl",
  "mx_4xlOn_2xl": "pf-v5-u-mx-4xl-on-2xl",
  "myAuto": "pf-v5-u-my-auto",
  "myAutoOnLg": "pf-v5-u-my-auto-on-lg",
  "myAutoOnMd": "pf-v5-u-my-auto-on-md",
  "myAutoOnSm": "pf-v5-u-my-auto-on-sm",
  "myAutoOnXl": "pf-v5-u-my-auto-on-xl",
  "myAutoOn_2xl": "pf-v5-u-my-auto-on-2xl",
  "myLg": "pf-v5-u-my-lg",
  "myLgOnLg": "pf-v5-u-my-lg-on-lg",
  "myLgOnMd": "pf-v5-u-my-lg-on-md",
  "myLgOnSm": "pf-v5-u-my-lg-on-sm",
  "myLgOnXl": "pf-v5-u-my-lg-on-xl",
  "myLgOn_2xl": "pf-v5-u-my-lg-on-2xl",
  "myMd": "pf-v5-u-my-md",
  "myMdOnLg": "pf-v5-u-my-md-on-lg",
  "myMdOnMd": "pf-v5-u-my-md-on-md",
  "myMdOnSm": "pf-v5-u-my-md-on-sm",
  "myMdOnXl": "pf-v5-u-my-md-on-xl",
  "myMdOn_2xl": "pf-v5-u-my-md-on-2xl",
  "mySm": "pf-v5-u-my-sm",
  "mySmOnLg": "pf-v5-u-my-sm-on-lg",
  "mySmOnMd": "pf-v5-u-my-sm-on-md",
  "mySmOnSm": "pf-v5-u-my-sm-on-sm",
  "mySmOnXl": "pf-v5-u-my-sm-on-xl",
  "mySmOn_2xl": "pf-v5-u-my-sm-on-2xl",
  "myXl": "pf-v5-u-my-xl",
  "myXlOnLg": "pf-v5-u-my-xl-on-lg",
  "myXlOnMd": "pf-v5-u-my-xl-on-md",
  "myXlOnSm": "pf-v5-u-my-xl-on-sm",
  "myXlOnXl": "pf-v5-u-my-xl-on-xl",
  "myXlOn_2xl": "pf-v5-u-my-xl-on-2xl",
  "myXs": "pf-v5-u-my-xs",
  "myXsOnLg": "pf-v5-u-my-xs-on-lg",
  "myXsOnMd": "pf-v5-u-my-xs-on-md",
  "myXsOnSm": "pf-v5-u-my-xs-on-sm",
  "myXsOnXl": "pf-v5-u-my-xs-on-xl",
  "myXsOn_2xl": "pf-v5-u-my-xs-on-2xl",
  "my_0": "pf-v5-u-my-0",
  "my_0OnLg": "pf-v5-u-my-0-on-lg",
  "my_0OnMd": "pf-v5-u-my-0-on-md",
  "my_0OnSm": "pf-v5-u-my-0-on-sm",
  "my_0OnXl": "pf-v5-u-my-0-on-xl",
  "my_0On_2xl": "pf-v5-u-my-0-on-2xl",
  "my_2xl": "pf-v5-u-my-2xl",
  "my_2xlOnLg": "pf-v5-u-my-2xl-on-lg",
  "my_2xlOnMd": "pf-v5-u-my-2xl-on-md",
  "my_2xlOnSm": "pf-v5-u-my-2xl-on-sm",
  "my_2xlOnXl": "pf-v5-u-my-2xl-on-xl",
  "my_2xlOn_2xl": "pf-v5-u-my-2xl-on-2xl",
  "my_3xl": "pf-v5-u-my-3xl",
  "my_3xlOnLg": "pf-v5-u-my-3xl-on-lg",
  "my_3xlOnMd": "pf-v5-u-my-3xl-on-md",
  "my_3xlOnSm": "pf-v5-u-my-3xl-on-sm",
  "my_3xlOnXl": "pf-v5-u-my-3xl-on-xl",
  "my_3xlOn_2xl": "pf-v5-u-my-3xl-on-2xl",
  "my_4xl": "pf-v5-u-my-4xl",
  "my_4xlOnLg": "pf-v5-u-my-4xl-on-lg",
  "my_4xlOnMd": "pf-v5-u-my-4xl-on-md",
  "my_4xlOnSm": "pf-v5-u-my-4xl-on-sm",
  "my_4xlOnXl": "pf-v5-u-my-4xl-on-xl",
  "my_4xlOn_2xl": "pf-v5-u-my-4xl-on-2xl",
  "pAuto": "pf-v5-u-p-auto",
  "pAutoOnLg": "pf-v5-u-p-auto-on-lg",
  "pAutoOnMd": "pf-v5-u-p-auto-on-md",
  "pAutoOnSm": "pf-v5-u-p-auto-on-sm",
  "pAutoOnXl": "pf-v5-u-p-auto-on-xl",
  "pAutoOn_2xl": "pf-v5-u-p-auto-on-2xl",
  "pLg": "pf-v5-u-p-lg",
  "pLgOnLg": "pf-v5-u-p-lg-on-lg",
  "pLgOnMd": "pf-v5-u-p-lg-on-md",
  "pLgOnSm": "pf-v5-u-p-lg-on-sm",
  "pLgOnXl": "pf-v5-u-p-lg-on-xl",
  "pLgOn_2xl": "pf-v5-u-p-lg-on-2xl",
  "pMd": "pf-v5-u-p-md",
  "pMdOnLg": "pf-v5-u-p-md-on-lg",
  "pMdOnMd": "pf-v5-u-p-md-on-md",
  "pMdOnSm": "pf-v5-u-p-md-on-sm",
  "pMdOnXl": "pf-v5-u-p-md-on-xl",
  "pMdOn_2xl": "pf-v5-u-p-md-on-2xl",
  "pSm": "pf-v5-u-p-sm",
  "pSmOnLg": "pf-v5-u-p-sm-on-lg",
  "pSmOnMd": "pf-v5-u-p-sm-on-md",
  "pSmOnSm": "pf-v5-u-p-sm-on-sm",
  "pSmOnXl": "pf-v5-u-p-sm-on-xl",
  "pSmOn_2xl": "pf-v5-u-p-sm-on-2xl",
  "pXl": "pf-v5-u-p-xl",
  "pXlOnLg": "pf-v5-u-p-xl-on-lg",
  "pXlOnMd": "pf-v5-u-p-xl-on-md",
  "pXlOnSm": "pf-v5-u-p-xl-on-sm",
  "pXlOnXl": "pf-v5-u-p-xl-on-xl",
  "pXlOn_2xl": "pf-v5-u-p-xl-on-2xl",
  "pXs": "pf-v5-u-p-xs",
  "pXsOnLg": "pf-v5-u-p-xs-on-lg",
  "pXsOnMd": "pf-v5-u-p-xs-on-md",
  "pXsOnSm": "pf-v5-u-p-xs-on-sm",
  "pXsOnXl": "pf-v5-u-p-xs-on-xl",
  "pXsOn_2xl": "pf-v5-u-p-xs-on-2xl",
  "p_0": "pf-v5-u-p-0",
  "p_0OnLg": "pf-v5-u-p-0-on-lg",
  "p_0OnMd": "pf-v5-u-p-0-on-md",
  "p_0OnSm": "pf-v5-u-p-0-on-sm",
  "p_0OnXl": "pf-v5-u-p-0-on-xl",
  "p_0On_2xl": "pf-v5-u-p-0-on-2xl",
  "p_2xl": "pf-v5-u-p-2xl",
  "p_2xlOnLg": "pf-v5-u-p-2xl-on-lg",
  "p_2xlOnMd": "pf-v5-u-p-2xl-on-md",
  "p_2xlOnSm": "pf-v5-u-p-2xl-on-sm",
  "p_2xlOnXl": "pf-v5-u-p-2xl-on-xl",
  "p_2xlOn_2xl": "pf-v5-u-p-2xl-on-2xl",
  "p_3xl": "pf-v5-u-p-3xl",
  "p_3xlOnLg": "pf-v5-u-p-3xl-on-lg",
  "p_3xlOnMd": "pf-v5-u-p-3xl-on-md",
  "p_3xlOnSm": "pf-v5-u-p-3xl-on-sm",
  "p_3xlOnXl": "pf-v5-u-p-3xl-on-xl",
  "p_3xlOn_2xl": "pf-v5-u-p-3xl-on-2xl",
  "p_4xl": "pf-v5-u-p-4xl",
  "p_4xlOnLg": "pf-v5-u-p-4xl-on-lg",
  "p_4xlOnMd": "pf-v5-u-p-4xl-on-md",
  "p_4xlOnSm": "pf-v5-u-p-4xl-on-sm",
  "p_4xlOnXl": "pf-v5-u-p-4xl-on-xl",
  "p_4xlOn_2xl": "pf-v5-u-p-4xl-on-2xl",
  "pbAuto": "pf-v5-u-pb-auto",
  "pbAutoOnLg": "pf-v5-u-pb-auto-on-lg",
  "pbAutoOnMd": "pf-v5-u-pb-auto-on-md",
  "pbAutoOnSm": "pf-v5-u-pb-auto-on-sm",
  "pbAutoOnXl": "pf-v5-u-pb-auto-on-xl",
  "pbAutoOn_2xl": "pf-v5-u-pb-auto-on-2xl",
  "pbLg": "pf-v5-u-pb-lg",
  "pbLgOnLg": "pf-v5-u-pb-lg-on-lg",
  "pbLgOnMd": "pf-v5-u-pb-lg-on-md",
  "pbLgOnSm": "pf-v5-u-pb-lg-on-sm",
  "pbLgOnXl": "pf-v5-u-pb-lg-on-xl",
  "pbLgOn_2xl": "pf-v5-u-pb-lg-on-2xl",
  "pbMd": "pf-v5-u-pb-md",
  "pbMdOnLg": "pf-v5-u-pb-md-on-lg",
  "pbMdOnMd": "pf-v5-u-pb-md-on-md",
  "pbMdOnSm": "pf-v5-u-pb-md-on-sm",
  "pbMdOnXl": "pf-v5-u-pb-md-on-xl",
  "pbMdOn_2xl": "pf-v5-u-pb-md-on-2xl",
  "pbSm": "pf-v5-u-pb-sm",
  "pbSmOnLg": "pf-v5-u-pb-sm-on-lg",
  "pbSmOnMd": "pf-v5-u-pb-sm-on-md",
  "pbSmOnSm": "pf-v5-u-pb-sm-on-sm",
  "pbSmOnXl": "pf-v5-u-pb-sm-on-xl",
  "pbSmOn_2xl": "pf-v5-u-pb-sm-on-2xl",
  "pbXl": "pf-v5-u-pb-xl",
  "pbXlOnLg": "pf-v5-u-pb-xl-on-lg",
  "pbXlOnMd": "pf-v5-u-pb-xl-on-md",
  "pbXlOnSm": "pf-v5-u-pb-xl-on-sm",
  "pbXlOnXl": "pf-v5-u-pb-xl-on-xl",
  "pbXlOn_2xl": "pf-v5-u-pb-xl-on-2xl",
  "pbXs": "pf-v5-u-pb-xs",
  "pbXsOnLg": "pf-v5-u-pb-xs-on-lg",
  "pbXsOnMd": "pf-v5-u-pb-xs-on-md",
  "pbXsOnSm": "pf-v5-u-pb-xs-on-sm",
  "pbXsOnXl": "pf-v5-u-pb-xs-on-xl",
  "pbXsOn_2xl": "pf-v5-u-pb-xs-on-2xl",
  "pb_0": "pf-v5-u-pb-0",
  "pb_0OnLg": "pf-v5-u-pb-0-on-lg",
  "pb_0OnMd": "pf-v5-u-pb-0-on-md",
  "pb_0OnSm": "pf-v5-u-pb-0-on-sm",
  "pb_0OnXl": "pf-v5-u-pb-0-on-xl",
  "pb_0On_2xl": "pf-v5-u-pb-0-on-2xl",
  "pb_2xl": "pf-v5-u-pb-2xl",
  "pb_2xlOnLg": "pf-v5-u-pb-2xl-on-lg",
  "pb_2xlOnMd": "pf-v5-u-pb-2xl-on-md",
  "pb_2xlOnSm": "pf-v5-u-pb-2xl-on-sm",
  "pb_2xlOnXl": "pf-v5-u-pb-2xl-on-xl",
  "pb_2xlOn_2xl": "pf-v5-u-pb-2xl-on-2xl",
  "pb_3xl": "pf-v5-u-pb-3xl",
  "pb_3xlOnLg": "pf-v5-u-pb-3xl-on-lg",
  "pb_3xlOnMd": "pf-v5-u-pb-3xl-on-md",
  "pb_3xlOnSm": "pf-v5-u-pb-3xl-on-sm",
  "pb_3xlOnXl": "pf-v5-u-pb-3xl-on-xl",
  "pb_3xlOn_2xl": "pf-v5-u-pb-3xl-on-2xl",
  "pb_4xl": "pf-v5-u-pb-4xl",
  "pb_4xlOnLg": "pf-v5-u-pb-4xl-on-lg",
  "pb_4xlOnMd": "pf-v5-u-pb-4xl-on-md",
  "pb_4xlOnSm": "pf-v5-u-pb-4xl-on-sm",
  "pb_4xlOnXl": "pf-v5-u-pb-4xl-on-xl",
  "pb_4xlOn_2xl": "pf-v5-u-pb-4xl-on-2xl",
  "plAuto": "pf-v5-u-pl-auto",
  "plAutoOnLg": "pf-v5-u-pl-auto-on-lg",
  "plAutoOnMd": "pf-v5-u-pl-auto-on-md",
  "plAutoOnSm": "pf-v5-u-pl-auto-on-sm",
  "plAutoOnXl": "pf-v5-u-pl-auto-on-xl",
  "plAutoOn_2xl": "pf-v5-u-pl-auto-on-2xl",
  "plLg": "pf-v5-u-pl-lg",
  "plLgOnLg": "pf-v5-u-pl-lg-on-lg",
  "plLgOnMd": "pf-v5-u-pl-lg-on-md",
  "plLgOnSm": "pf-v5-u-pl-lg-on-sm",
  "plLgOnXl": "pf-v5-u-pl-lg-on-xl",
  "plLgOn_2xl": "pf-v5-u-pl-lg-on-2xl",
  "plMd": "pf-v5-u-pl-md",
  "plMdOnLg": "pf-v5-u-pl-md-on-lg",
  "plMdOnMd": "pf-v5-u-pl-md-on-md",
  "plMdOnSm": "pf-v5-u-pl-md-on-sm",
  "plMdOnXl": "pf-v5-u-pl-md-on-xl",
  "plMdOn_2xl": "pf-v5-u-pl-md-on-2xl",
  "plSm": "pf-v5-u-pl-sm",
  "plSmOnLg": "pf-v5-u-pl-sm-on-lg",
  "plSmOnMd": "pf-v5-u-pl-sm-on-md",
  "plSmOnSm": "pf-v5-u-pl-sm-on-sm",
  "plSmOnXl": "pf-v5-u-pl-sm-on-xl",
  "plSmOn_2xl": "pf-v5-u-pl-sm-on-2xl",
  "plXl": "pf-v5-u-pl-xl",
  "plXlOnLg": "pf-v5-u-pl-xl-on-lg",
  "plXlOnMd": "pf-v5-u-pl-xl-on-md",
  "plXlOnSm": "pf-v5-u-pl-xl-on-sm",
  "plXlOnXl": "pf-v5-u-pl-xl-on-xl",
  "plXlOn_2xl": "pf-v5-u-pl-xl-on-2xl",
  "plXs": "pf-v5-u-pl-xs",
  "plXsOnLg": "pf-v5-u-pl-xs-on-lg",
  "plXsOnMd": "pf-v5-u-pl-xs-on-md",
  "plXsOnSm": "pf-v5-u-pl-xs-on-sm",
  "plXsOnXl": "pf-v5-u-pl-xs-on-xl",
  "plXsOn_2xl": "pf-v5-u-pl-xs-on-2xl",
  "pl_0": "pf-v5-u-pl-0",
  "pl_0OnLg": "pf-v5-u-pl-0-on-lg",
  "pl_0OnMd": "pf-v5-u-pl-0-on-md",
  "pl_0OnSm": "pf-v5-u-pl-0-on-sm",
  "pl_0OnXl": "pf-v5-u-pl-0-on-xl",
  "pl_0On_2xl": "pf-v5-u-pl-0-on-2xl",
  "pl_2xl": "pf-v5-u-pl-2xl",
  "pl_2xlOnLg": "pf-v5-u-pl-2xl-on-lg",
  "pl_2xlOnMd": "pf-v5-u-pl-2xl-on-md",
  "pl_2xlOnSm": "pf-v5-u-pl-2xl-on-sm",
  "pl_2xlOnXl": "pf-v5-u-pl-2xl-on-xl",
  "pl_2xlOn_2xl": "pf-v5-u-pl-2xl-on-2xl",
  "pl_3xl": "pf-v5-u-pl-3xl",
  "pl_3xlOnLg": "pf-v5-u-pl-3xl-on-lg",
  "pl_3xlOnMd": "pf-v5-u-pl-3xl-on-md",
  "pl_3xlOnSm": "pf-v5-u-pl-3xl-on-sm",
  "pl_3xlOnXl": "pf-v5-u-pl-3xl-on-xl",
  "pl_3xlOn_2xl": "pf-v5-u-pl-3xl-on-2xl",
  "pl_4xl": "pf-v5-u-pl-4xl",
  "pl_4xlOnLg": "pf-v5-u-pl-4xl-on-lg",
  "pl_4xlOnMd": "pf-v5-u-pl-4xl-on-md",
  "pl_4xlOnSm": "pf-v5-u-pl-4xl-on-sm",
  "pl_4xlOnXl": "pf-v5-u-pl-4xl-on-xl",
  "pl_4xlOn_2xl": "pf-v5-u-pl-4xl-on-2xl",
  "prAuto": "pf-v5-u-pr-auto",
  "prAutoOnLg": "pf-v5-u-pr-auto-on-lg",
  "prAutoOnMd": "pf-v5-u-pr-auto-on-md",
  "prAutoOnSm": "pf-v5-u-pr-auto-on-sm",
  "prAutoOnXl": "pf-v5-u-pr-auto-on-xl",
  "prAutoOn_2xl": "pf-v5-u-pr-auto-on-2xl",
  "prLg": "pf-v5-u-pr-lg",
  "prLgOnLg": "pf-v5-u-pr-lg-on-lg",
  "prLgOnMd": "pf-v5-u-pr-lg-on-md",
  "prLgOnSm": "pf-v5-u-pr-lg-on-sm",
  "prLgOnXl": "pf-v5-u-pr-lg-on-xl",
  "prLgOn_2xl": "pf-v5-u-pr-lg-on-2xl",
  "prMd": "pf-v5-u-pr-md",
  "prMdOnLg": "pf-v5-u-pr-md-on-lg",
  "prMdOnMd": "pf-v5-u-pr-md-on-md",
  "prMdOnSm": "pf-v5-u-pr-md-on-sm",
  "prMdOnXl": "pf-v5-u-pr-md-on-xl",
  "prMdOn_2xl": "pf-v5-u-pr-md-on-2xl",
  "prSm": "pf-v5-u-pr-sm",
  "prSmOnLg": "pf-v5-u-pr-sm-on-lg",
  "prSmOnMd": "pf-v5-u-pr-sm-on-md",
  "prSmOnSm": "pf-v5-u-pr-sm-on-sm",
  "prSmOnXl": "pf-v5-u-pr-sm-on-xl",
  "prSmOn_2xl": "pf-v5-u-pr-sm-on-2xl",
  "prXl": "pf-v5-u-pr-xl",
  "prXlOnLg": "pf-v5-u-pr-xl-on-lg",
  "prXlOnMd": "pf-v5-u-pr-xl-on-md",
  "prXlOnSm": "pf-v5-u-pr-xl-on-sm",
  "prXlOnXl": "pf-v5-u-pr-xl-on-xl",
  "prXlOn_2xl": "pf-v5-u-pr-xl-on-2xl",
  "prXs": "pf-v5-u-pr-xs",
  "prXsOnLg": "pf-v5-u-pr-xs-on-lg",
  "prXsOnMd": "pf-v5-u-pr-xs-on-md",
  "prXsOnSm": "pf-v5-u-pr-xs-on-sm",
  "prXsOnXl": "pf-v5-u-pr-xs-on-xl",
  "prXsOn_2xl": "pf-v5-u-pr-xs-on-2xl",
  "pr_0": "pf-v5-u-pr-0",
  "pr_0OnLg": "pf-v5-u-pr-0-on-lg",
  "pr_0OnMd": "pf-v5-u-pr-0-on-md",
  "pr_0OnSm": "pf-v5-u-pr-0-on-sm",
  "pr_0OnXl": "pf-v5-u-pr-0-on-xl",
  "pr_0On_2xl": "pf-v5-u-pr-0-on-2xl",
  "pr_2xl": "pf-v5-u-pr-2xl",
  "pr_2xlOnLg": "pf-v5-u-pr-2xl-on-lg",
  "pr_2xlOnMd": "pf-v5-u-pr-2xl-on-md",
  "pr_2xlOnSm": "pf-v5-u-pr-2xl-on-sm",
  "pr_2xlOnXl": "pf-v5-u-pr-2xl-on-xl",
  "pr_2xlOn_2xl": "pf-v5-u-pr-2xl-on-2xl",
  "pr_3xl": "pf-v5-u-pr-3xl",
  "pr_3xlOnLg": "pf-v5-u-pr-3xl-on-lg",
  "pr_3xlOnMd": "pf-v5-u-pr-3xl-on-md",
  "pr_3xlOnSm": "pf-v5-u-pr-3xl-on-sm",
  "pr_3xlOnXl": "pf-v5-u-pr-3xl-on-xl",
  "pr_3xlOn_2xl": "pf-v5-u-pr-3xl-on-2xl",
  "pr_4xl": "pf-v5-u-pr-4xl",
  "pr_4xlOnLg": "pf-v5-u-pr-4xl-on-lg",
  "pr_4xlOnMd": "pf-v5-u-pr-4xl-on-md",
  "pr_4xlOnSm": "pf-v5-u-pr-4xl-on-sm",
  "pr_4xlOnXl": "pf-v5-u-pr-4xl-on-xl",
  "pr_4xlOn_2xl": "pf-v5-u-pr-4xl-on-2xl",
  "ptAuto": "pf-v5-u-pt-auto",
  "ptAutoOnLg": "pf-v5-u-pt-auto-on-lg",
  "ptAutoOnMd": "pf-v5-u-pt-auto-on-md",
  "ptAutoOnSm": "pf-v5-u-pt-auto-on-sm",
  "ptAutoOnXl": "pf-v5-u-pt-auto-on-xl",
  "ptAutoOn_2xl": "pf-v5-u-pt-auto-on-2xl",
  "ptLg": "pf-v5-u-pt-lg",
  "ptLgOnLg": "pf-v5-u-pt-lg-on-lg",
  "ptLgOnMd": "pf-v5-u-pt-lg-on-md",
  "ptLgOnSm": "pf-v5-u-pt-lg-on-sm",
  "ptLgOnXl": "pf-v5-u-pt-lg-on-xl",
  "ptLgOn_2xl": "pf-v5-u-pt-lg-on-2xl",
  "ptMd": "pf-v5-u-pt-md",
  "ptMdOnLg": "pf-v5-u-pt-md-on-lg",
  "ptMdOnMd": "pf-v5-u-pt-md-on-md",
  "ptMdOnSm": "pf-v5-u-pt-md-on-sm",
  "ptMdOnXl": "pf-v5-u-pt-md-on-xl",
  "ptMdOn_2xl": "pf-v5-u-pt-md-on-2xl",
  "ptSm": "pf-v5-u-pt-sm",
  "ptSmOnLg": "pf-v5-u-pt-sm-on-lg",
  "ptSmOnMd": "pf-v5-u-pt-sm-on-md",
  "ptSmOnSm": "pf-v5-u-pt-sm-on-sm",
  "ptSmOnXl": "pf-v5-u-pt-sm-on-xl",
  "ptSmOn_2xl": "pf-v5-u-pt-sm-on-2xl",
  "ptXl": "pf-v5-u-pt-xl",
  "ptXlOnLg": "pf-v5-u-pt-xl-on-lg",
  "ptXlOnMd": "pf-v5-u-pt-xl-on-md",
  "ptXlOnSm": "pf-v5-u-pt-xl-on-sm",
  "ptXlOnXl": "pf-v5-u-pt-xl-on-xl",
  "ptXlOn_2xl": "pf-v5-u-pt-xl-on-2xl",
  "ptXs": "pf-v5-u-pt-xs",
  "ptXsOnLg": "pf-v5-u-pt-xs-on-lg",
  "ptXsOnMd": "pf-v5-u-pt-xs-on-md",
  "ptXsOnSm": "pf-v5-u-pt-xs-on-sm",
  "ptXsOnXl": "pf-v5-u-pt-xs-on-xl",
  "ptXsOn_2xl": "pf-v5-u-pt-xs-on-2xl",
  "pt_0": "pf-v5-u-pt-0",
  "pt_0OnLg": "pf-v5-u-pt-0-on-lg",
  "pt_0OnMd": "pf-v5-u-pt-0-on-md",
  "pt_0OnSm": "pf-v5-u-pt-0-on-sm",
  "pt_0OnXl": "pf-v5-u-pt-0-on-xl",
  "pt_0On_2xl": "pf-v5-u-pt-0-on-2xl",
  "pt_2xl": "pf-v5-u-pt-2xl",
  "pt_2xlOnLg": "pf-v5-u-pt-2xl-on-lg",
  "pt_2xlOnMd": "pf-v5-u-pt-2xl-on-md",
  "pt_2xlOnSm": "pf-v5-u-pt-2xl-on-sm",
  "pt_2xlOnXl": "pf-v5-u-pt-2xl-on-xl",
  "pt_2xlOn_2xl": "pf-v5-u-pt-2xl-on-2xl",
  "pt_3xl": "pf-v5-u-pt-3xl",
  "pt_3xlOnLg": "pf-v5-u-pt-3xl-on-lg",
  "pt_3xlOnMd": "pf-v5-u-pt-3xl-on-md",
  "pt_3xlOnSm": "pf-v5-u-pt-3xl-on-sm",
  "pt_3xlOnXl": "pf-v5-u-pt-3xl-on-xl",
  "pt_3xlOn_2xl": "pf-v5-u-pt-3xl-on-2xl",
  "pt_4xl": "pf-v5-u-pt-4xl",
  "pt_4xlOnLg": "pf-v5-u-pt-4xl-on-lg",
  "pt_4xlOnMd": "pf-v5-u-pt-4xl-on-md",
  "pt_4xlOnSm": "pf-v5-u-pt-4xl-on-sm",
  "pt_4xlOnXl": "pf-v5-u-pt-4xl-on-xl",
  "pt_4xlOn_2xl": "pf-v5-u-pt-4xl-on-2xl",
  "pxAuto": "pf-v5-u-px-auto",
  "pxAutoOnLg": "pf-v5-u-px-auto-on-lg",
  "pxAutoOnMd": "pf-v5-u-px-auto-on-md",
  "pxAutoOnSm": "pf-v5-u-px-auto-on-sm",
  "pxAutoOnXl": "pf-v5-u-px-auto-on-xl",
  "pxAutoOn_2xl": "pf-v5-u-px-auto-on-2xl",
  "pxLg": "pf-v5-u-px-lg",
  "pxLgOnLg": "pf-v5-u-px-lg-on-lg",
  "pxLgOnMd": "pf-v5-u-px-lg-on-md",
  "pxLgOnSm": "pf-v5-u-px-lg-on-sm",
  "pxLgOnXl": "pf-v5-u-px-lg-on-xl",
  "pxLgOn_2xl": "pf-v5-u-px-lg-on-2xl",
  "pxMd": "pf-v5-u-px-md",
  "pxMdOnLg": "pf-v5-u-px-md-on-lg",
  "pxMdOnMd": "pf-v5-u-px-md-on-md",
  "pxMdOnSm": "pf-v5-u-px-md-on-sm",
  "pxMdOnXl": "pf-v5-u-px-md-on-xl",
  "pxMdOn_2xl": "pf-v5-u-px-md-on-2xl",
  "pxSm": "pf-v5-u-px-sm",
  "pxSmOnLg": "pf-v5-u-px-sm-on-lg",
  "pxSmOnMd": "pf-v5-u-px-sm-on-md",
  "pxSmOnSm": "pf-v5-u-px-sm-on-sm",
  "pxSmOnXl": "pf-v5-u-px-sm-on-xl",
  "pxSmOn_2xl": "pf-v5-u-px-sm-on-2xl",
  "pxXl": "pf-v5-u-px-xl",
  "pxXlOnLg": "pf-v5-u-px-xl-on-lg",
  "pxXlOnMd": "pf-v5-u-px-xl-on-md",
  "pxXlOnSm": "pf-v5-u-px-xl-on-sm",
  "pxXlOnXl": "pf-v5-u-px-xl-on-xl",
  "pxXlOn_2xl": "pf-v5-u-px-xl-on-2xl",
  "pxXs": "pf-v5-u-px-xs",
  "pxXsOnLg": "pf-v5-u-px-xs-on-lg",
  "pxXsOnMd": "pf-v5-u-px-xs-on-md",
  "pxXsOnSm": "pf-v5-u-px-xs-on-sm",
  "pxXsOnXl": "pf-v5-u-px-xs-on-xl",
  "pxXsOn_2xl": "pf-v5-u-px-xs-on-2xl",
  "px_0": "pf-v5-u-px-0",
  "px_0OnLg": "pf-v5-u-px-0-on-lg",
  "px_0OnMd": "pf-v5-u-px-0-on-md",
  "px_0OnSm": "pf-v5-u-px-0-on-sm",
  "px_0OnXl": "pf-v5-u-px-0-on-xl",
  "px_0On_2xl": "pf-v5-u-px-0-on-2xl",
  "px_2xl": "pf-v5-u-px-2xl",
  "px_2xlOnLg": "pf-v5-u-px-2xl-on-lg",
  "px_2xlOnMd": "pf-v5-u-px-2xl-on-md",
  "px_2xlOnSm": "pf-v5-u-px-2xl-on-sm",
  "px_2xlOnXl": "pf-v5-u-px-2xl-on-xl",
  "px_2xlOn_2xl": "pf-v5-u-px-2xl-on-2xl",
  "px_3xl": "pf-v5-u-px-3xl",
  "px_3xlOnLg": "pf-v5-u-px-3xl-on-lg",
  "px_3xlOnMd": "pf-v5-u-px-3xl-on-md",
  "px_3xlOnSm": "pf-v5-u-px-3xl-on-sm",
  "px_3xlOnXl": "pf-v5-u-px-3xl-on-xl",
  "px_3xlOn_2xl": "pf-v5-u-px-3xl-on-2xl",
  "px_4xl": "pf-v5-u-px-4xl",
  "px_4xlOnLg": "pf-v5-u-px-4xl-on-lg",
  "px_4xlOnMd": "pf-v5-u-px-4xl-on-md",
  "px_4xlOnSm": "pf-v5-u-px-4xl-on-sm",
  "px_4xlOnXl": "pf-v5-u-px-4xl-on-xl",
  "px_4xlOn_2xl": "pf-v5-u-px-4xl-on-2xl",
  "pyAuto": "pf-v5-u-py-auto",
  "pyAutoOnLg": "pf-v5-u-py-auto-on-lg",
  "pyAutoOnMd": "pf-v5-u-py-auto-on-md",
  "pyAutoOnSm": "pf-v5-u-py-auto-on-sm",
  "pyAutoOnXl": "pf-v5-u-py-auto-on-xl",
  "pyAutoOn_2xl": "pf-v5-u-py-auto-on-2xl",
  "pyLg": "pf-v5-u-py-lg",
  "pyLgOnLg": "pf-v5-u-py-lg-on-lg",
  "pyLgOnMd": "pf-v5-u-py-lg-on-md",
  "pyLgOnSm": "pf-v5-u-py-lg-on-sm",
  "pyLgOnXl": "pf-v5-u-py-lg-on-xl",
  "pyLgOn_2xl": "pf-v5-u-py-lg-on-2xl",
  "pyMd": "pf-v5-u-py-md",
  "pyMdOnLg": "pf-v5-u-py-md-on-lg",
  "pyMdOnMd": "pf-v5-u-py-md-on-md",
  "pyMdOnSm": "pf-v5-u-py-md-on-sm",
  "pyMdOnXl": "pf-v5-u-py-md-on-xl",
  "pyMdOn_2xl": "pf-v5-u-py-md-on-2xl",
  "pySm": "pf-v5-u-py-sm",
  "pySmOnLg": "pf-v5-u-py-sm-on-lg",
  "pySmOnMd": "pf-v5-u-py-sm-on-md",
  "pySmOnSm": "pf-v5-u-py-sm-on-sm",
  "pySmOnXl": "pf-v5-u-py-sm-on-xl",
  "pySmOn_2xl": "pf-v5-u-py-sm-on-2xl",
  "pyXl": "pf-v5-u-py-xl",
  "pyXlOnLg": "pf-v5-u-py-xl-on-lg",
  "pyXlOnMd": "pf-v5-u-py-xl-on-md",
  "pyXlOnSm": "pf-v5-u-py-xl-on-sm",
  "pyXlOnXl": "pf-v5-u-py-xl-on-xl",
  "pyXlOn_2xl": "pf-v5-u-py-xl-on-2xl",
  "pyXs": "pf-v5-u-py-xs",
  "pyXsOnLg": "pf-v5-u-py-xs-on-lg",
  "pyXsOnMd": "pf-v5-u-py-xs-on-md",
  "pyXsOnSm": "pf-v5-u-py-xs-on-sm",
  "pyXsOnXl": "pf-v5-u-py-xs-on-xl",
  "pyXsOn_2xl": "pf-v5-u-py-xs-on-2xl",
  "py_0": "pf-v5-u-py-0",
  "py_0OnLg": "pf-v5-u-py-0-on-lg",
  "py_0OnMd": "pf-v5-u-py-0-on-md",
  "py_0OnSm": "pf-v5-u-py-0-on-sm",
  "py_0OnXl": "pf-v5-u-py-0-on-xl",
  "py_0On_2xl": "pf-v5-u-py-0-on-2xl",
  "py_2xl": "pf-v5-u-py-2xl",
  "py_2xlOnLg": "pf-v5-u-py-2xl-on-lg",
  "py_2xlOnMd": "pf-v5-u-py-2xl-on-md",
  "py_2xlOnSm": "pf-v5-u-py-2xl-on-sm",
  "py_2xlOnXl": "pf-v5-u-py-2xl-on-xl",
  "py_2xlOn_2xl": "pf-v5-u-py-2xl-on-2xl",
  "py_3xl": "pf-v5-u-py-3xl",
  "py_3xlOnLg": "pf-v5-u-py-3xl-on-lg",
  "py_3xlOnMd": "pf-v5-u-py-3xl-on-md",
  "py_3xlOnSm": "pf-v5-u-py-3xl-on-sm",
  "py_3xlOnXl": "pf-v5-u-py-3xl-on-xl",
  "py_3xlOn_2xl": "pf-v5-u-py-3xl-on-2xl",
  "py_4xl": "pf-v5-u-py-4xl",
  "py_4xlOnLg": "pf-v5-u-py-4xl-on-lg",
  "py_4xlOnMd": "pf-v5-u-py-4xl-on-md",
  "py_4xlOnSm": "pf-v5-u-py-4xl-on-sm",
  "py_4xlOnXl": "pf-v5-u-py-4xl-on-xl",
  "py_4xlOn_2xl": "pf-v5-u-py-4xl-on-2xl"
};